var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paths.length)?_c('svg',{staticClass:"proto-icon",attrs:{"viewBox":"0 0 24 24","width":_vm.size,"height":_vm.size,"aria-hidden":"true"}},_vm._l((_vm.paths),function(d,i){return _c('path',{key:i,attrs:{"d":d}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }